class VgSubscriptions {
	static PERIOD_UNIT_DAY   = 'DAY';
	static PERIOD_UNIT_MONTH = 'MONTH';

	static SUBSCRIPTION_TYPE_CASH = 'CASH';
	static SUBSCRIPTION_TYPE_EFT  = 'EFT';

	static BINDING_SUBSCRIPTIONS_FILTER = 'BINDING';
	static ONE_SUBSCRIPTIONS_FILTER = 'ONE';
	static FLEX_SUBSCRIPTIONS_FILTER = 'FLEX';
	static PRIME_SUBSCRIPTIONS_FILTER = 'PRIME';

	static getMainSubscriptions(subscriptionsData) {
		return subscriptionsData.subscriptions.filter(sub =>
			!this.isDaypassSubscription(sub)
			&& !this.isBindingSubscription(sub)
			&& !this.isStudentSubscription(sub)
		) ?? []
	}

	static getOneSubscriptions(subscriptionsData){
		return subscriptionsData.subscriptions.filter(sub =>
			this.isOneSubscription(sub)
			&& !this.isStudentSubscription(sub)
		) ?? []
	}

	static getBindingSubscriptions(subscriptionsData) {
		return subscriptionsData.subscriptions.filter(sub =>
			this.isBindingSubscription(sub)
		) ?? []
	}

	static getDayPassSubscriptions(subscriptionsData) {
		return subscriptionsData.subscriptions.filter(sub =>
			this.isDaypassSubscription(sub)
		) ?? []
	}

	static getStudentSubscriptions(subscriptionsData){
		return subscriptionsData.subscriptions.filter(sub =>
			this.isStudentSubscription(sub)
		) ?? []
	}

	static getStudentReferencePrice(studentSubscription, subscriptionsData) {
		const globalId = studentSubscription.product.globalId;
		const prefix = globalId.split('_25')[0];

		const referenceSubscription = this.getMainSubscriptions(subscriptionsData).find(sub =>
			sub.product.globalId.startsWith(prefix)
		);

		return referenceSubscription?.periodPrice ?? null;
	}

	static getBindingMonths(subscription) {
		return subscription.binding ?? subscription.bindingPeriodLength ?? 0;
	}

	static filterByLockAndDuration(subscriptionsData, lockIn, months) {
		if (lockIn !== 'lock-in') {
			return this.getMainSubscriptions(subscriptionsData);
		}

		return this.getBindingSubscriptions(subscriptionsData).filter(sub =>
			this.getBindingMonths(sub) === parseInt(months, 10)
		);
	}

	static parseSubscriptionLabel(subscriptionName) {
		const label = subscriptionName.toLowerCase();

		if (label.includes('binding')) {
			return label.trim().split(' ')[0];
		}

		return label.replace('cuota ', '').replace('corporate ', '');
	}

	static haveOneFlexOrPrimeSubscription(subscriptionsData) {
		return subscriptionsData.subscriptions.some(sub => vgHelpersData.global_ids.subOneFlexPrimeId.includes(sub.product.globalId));
	}

	static haveFlexSubscription(subscriptionsData) {
		return subscriptionsData.subscriptions.some(sub => this.isFlexSubscription(sub));
	}

	static isOneSubscription(subscription) {
		return subscription.product.globalId.includes(this.ONE_SUBSCRIPTIONS_FILTER);
	}

	static isFlexSubscription(subscription) {
		return subscription.product.globalId.includes(this.FLEX_SUBSCRIPTIONS_FILTER);
	}

	static isPrimeSubscription(subscription) {
		return subscription.product.globalId.includes(this.PRIME_SUBSCRIPTIONS_FILTER);
	}

	static isDaypassSubscription(subscription){
		return subscription?.periodUnit === this.PERIOD_UNIT_DAY;
	}

	static isStudentSubscription(subscription){
		return vgHelpersData.global_ids.studentGlobalId.some(globalId =>
			subscription.product.globalId.includes(globalId)
		);
	}

	static isBindingSubscription(subscription){
		return subscription.binding !== 0;
	}

	static haveParking(subscriptionsData) {
		return subscriptionsData.subscriptions.some(sub => sub.parking === true);
	}

	static haveFreeWater(subscriptionsData) {
		return subscriptionsData.subscriptions.some(sub => sub.freeWater === true);
	}

	static getWaterAddonName(subscriptionsData) {
		for (const sub of subscriptionsData.subscriptions) {
			const addon = sub.availableAddOnProducts?.find(
				(a) => vgHelpersData.global_ids.waterGlobalId.includes(a.productGroupName)
			);
			if (addon) {
				return addon.webname;
			}
		}
		return null;
	}

	static getFeaturedSubscription(subscriptionsData) {
		const mainSubscriptions = subscriptionsData.subscriptions.filter(sub => !this.isDaypassSubscription(sub));

		if (mainSubscriptions.length === 1) {
			return mainSubscriptions[0];
		}

		return mainSubscriptions.find(sub => sub.product.mostPopular) ?? null;
	}

	static getSubscriptionByGlobalId(globalId, subscriptionsData) {
		return subscriptionsData.subscriptions.find(sub => sub.product.globalId === globalId) ?? null;
	}

	static subscriptionsHasStudent(subscriptionsData) {
		return subscriptionsData.subscriptions?.some(sub => this.isStudentSubscription(sub)) ?? false;
	}

	static subscriptionsHasDaypass(subscriptionsData) {
		return subscriptionsData.subscriptions?.some(sub => this.isDaypassSubscription(sub)) ?? false;
	}

	static subscriptionsHasAddons(subscriptionsData) {
		return subscriptionsData.subscriptions.some(subscription => this.subscriptionHasAddons(subscription));
	}

	static subscriptionHasAddons(subscription) {
		return subscription.availableAddOnProducts && subscription.availableAddOnProducts.length > 0;
	}

	static subscriptionsHasClipcards(subscriptionsData) {
		return subscriptionsData.clipcards && subscriptionsData.clipcards.length > 0;
	}

}
